export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";

// actions for feeback
export const ADD_FEEDBACK = "ADD_FEEDBACK";
export const REMOVE_FEEBACK = "REMOVE_FEEBACK";

// actions for checkout
export const ADD_TO_CHECKOUT = "ADD_TO_CHECKOUT";
export const REMOVE_FROM_CHECKOUT = "REMOVE_FROM_CHECKOUT";